import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "scorm",
    title: "SCORM",
    icon: require("./content-icon.svg"),
    category: "multimedia",
    Viewer,
    Editor,
    Preview: Viewer
}